import { Template } from '../../store/interfaces';
import { templateSlice, defaultTemplateSlice } from '../reducers/templateSlice';
import { getStore } from '../store';

export const templateProvider = (): {
  setTemplate: (template: Template) => { payload: Template; type: 'template/setTemplate' };
} => {
  const { dispatch } = getStore();
  const { setTemplate } = templateSlice.actions;
  return {
    setTemplate: (template: Template) => dispatch(setTemplate(template)),
  };
};

export const defaultTemplateProvider = (): {
  setDefaultTemplate: (template: Template) => { payload: Template; type: 'defaultTemplate/setDefaultTemplate' };
} => {
  const { dispatch } = getStore();
  const { setDefaultTemplate } = defaultTemplateSlice.actions;
  return {
    setDefaultTemplate: (template: Template) => dispatch(setDefaultTemplate(template)),
  };
};
